import { Component, OnInit, ViewChild } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {IOption} from 'ng-select';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { UserService } from 'app/users/shared/user.service';
import { FormGroup, FormControl } from '@angular/forms';
import { HRMSService } from '../shared/hrms.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css'],
  animations: [fadeInOutTranslate]
})
export class EmployeeComponent implements OnInit {
  employees:any;
  employeesList:any;
  myEmployees: Array<IOption> = [];
  myDepartments: Array<IOption> = [];
  mySearchForm: FormGroup;
  departments:any;
  branchOptions: Array<IOption>;
  @ViewChild("tabRef") tabRef;
  constructor(private userService:UserService,private hrmsService:HRMSService, private ls:LogisticsService) { }

  ngOnInit() {
    this.getAllEmployees();
    this.initializeForm();
    this.getAllDepartments();
    this.getAllBranch();

  }
  myOptions: Array<IOption> = [
    {label: 'John Mathew', value: 'BE'},
    {label: 'Maria Shawn', value: 'LU'},
    {label: 'Chris Mathew', value: 'BE'},
    {label: 'Shain Nathan', value: 'LU'},
    {label: 'John Mathew', value: 'BE'},
    {label: 'Maria Ashley', value: 'LU'},
    {label: 'Lamrath Abdulllah', value: 'NL'}
  ];

  myDept: Array<IOption> = [
    {label: 'All', value: 'all'},
    {label: 'HR', value: 'hr'},
    {label: 'Accounts', value: 'accounts'},
    {label: 'Field workers', value: 'fw'}
  ];

  companyassets: Array<IOption> = [
    {label: 'Mobile', value: 'mobile'},
    {label: 'Laptop', value: 'laptop'},
    {label: 'Phone', value: 'phone'},
    {label: 'Car', value: 'car'}
  ];

  myRoles: Array<IOption> = [
    {label: 'All', value: 'all'},
    {label: 'Supervisor', value: 'supervisor'},
    {label: 'Admin', value: 'admin'},
    {label: 'Driver', value: 'driver'},
    {label: 'Super Admin', value: 'super admin'}
  ];

  public getAllEmployees()
  {
  var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.employees = [];
    this.myEmployees = [];
    this.employeesList = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
      if(!(element.payload.child("role").val() == "customer"))
      {
        y["$key"] = element.key;
        this.employees.push(y);
        this.employeesList.push(y);
        this.myEmployees.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("name").val())});
      }
    });
  });
}
public getAllDepartments()
{
  var x = this.hrmsService.getAllDepartments();
  x.snapshotChanges().subscribe(item=>{
  this.myDepartments = [];
  this.departments = {};
    item.forEach(element =>{
        this.myDepartments.push({label: String(element.payload.child("name").val()), value: element.key});
        this.departments[element.key] = element.payload.child("name").val();
    });
  });
}
getAllBranch()
{
  this.ls.getBranch().snapshotChanges().subscribe(data=>{
    this.branchOptions  = [];
    data.forEach(branch=>{
      this.branchOptions.push({
        label: branch.payload.child("name").val(),
        value: branch.payload.key
      })
    });
  });
}
public initializeForm()
{
  this.mySearchForm = new FormGroup({
    employee: new FormControl(''),
    department: new FormControl(''),
    role: new FormControl('')
  });
}
public onSubmit()
{
  this.employees = [];
  this.employeesList.forEach(e=>{
    if(e.name === this.mySearchForm.value.employee || e.department === this.mySearchForm.value.department || e.role === this.mySearchForm.value.role)
    {
      this.employees.push(e);
    }
  });
}
public clear():void{
  //this.employees = this.employeesList;
  this.ngOnInit();
}
receiveMessage($event) {
  this.tabRef.activeId = $event;
}
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/employee/employee.component.ts